import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { userId } from "../config";
export type SectionKey = "herosection" | "servicesection" | "testimonialsection" | "microsite"|"aboutsection"|"gallerysection"|"footersection"|"fronttheme"|"aboutuspage";
export type SectionState = "On" | "Off";

export type SectionCompletion = Record<SectionKey, boolean>;

interface SectionContextType {
  sections: Record<SectionKey, SectionState>;
  completions: SectionCompletion;
  setSectionState: (key: SectionKey, state: SectionState) => void;
  markSectionComplete: (key: SectionKey, complete: boolean) => void;
  isSectionActive: (key: SectionKey) => boolean;
  isSectionComplete: (key: SectionKey) => boolean;
}


const SectionContext = createContext<SectionContextType | undefined>(undefined);

export const SectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  const [sections, setSections] = useLocalStorage<Record<SectionKey, SectionState>>(
    `${userId}_microsite_sections`,
    {
      herosection: "On",
      servicesection: "On",
      testimonialsection: "On",
      microsite: "On",
      aboutsection:"On",
      gallerysection:"On",
      footersection:"On",
      fronttheme: "On",
      aboutuspage: "On"
    }
  );

  const [completions, setCompletions] = useLocalStorage<SectionCompletion>(
    `${userId}_microsite_completions`,
    {
      herosection: false,
      servicesection: false,
      testimonialsection: false,
      microsite: false,
      aboutsection:false,
      gallerysection:false,
      footersection:false,
      fronttheme: false,
      aboutuspage: false
    }
  );

  useEffect(() => {
    const defaultSections: Record<SectionKey, SectionState> = {
      herosection: "On",
      servicesection: "On",
      testimonialsection: "On",
      microsite: "On",
      gallerysection:"On",
      aboutsection:"On",
      footersection:"On",
      fronttheme: "On",
      aboutuspage: "On"
    };
    const defaultCompletions: SectionCompletion = {
      herosection: false,
      servicesection: false,
      testimonialsection: false,
      microsite: false,
      gallerysection:false,
      aboutsection:false,
      footersection:false,
      fronttheme: false,
      aboutuspage: false
    };
    setSections((prev) => {
      const updated = { ...defaultSections, ...prev };
      return updated;
    });

    setCompletions((prev) => {
      
      const updated = { ...defaultCompletions, ...prev };
      return updated;
    });
  }, [setSections, setCompletions]);

  const setSectionState = (key: SectionKey, state: SectionState) => {
    setSections((prev) => ({ ...prev, [key]: state }));
  };

  const markSectionComplete = (key: SectionKey, complete: boolean) => {
    setCompletions((prev) => {
      const updated = { ...prev, [key]: complete };
      return updated;
    });
  };

  const isSectionActive = (key: SectionKey) => sections[key] === "On";
  const isSectionComplete = (key: SectionKey) => {
    return completions[key];
  };

  return (
    <SectionContext.Provider
      value={{
        sections,
        completions,
        setSectionState,
        markSectionComplete,
        isSectionActive,
        isSectionComplete,
      }}
    >
      {children}
    </SectionContext.Provider>
  );
};

export const useSectionContext = (): SectionContextType => {
  const ctx = useContext(SectionContext);
  if (!ctx) throw new Error("useSectionContext must be used within SectionProvider");
  return ctx;
};
